export default {"src":"/_next/static/media/overlay.d86a559d.svg","height":321,"width":636,"blurWidth":0,"blurHeight":0};